<form nz-form [formGroup]="form" (ngSubmit)="submit()" role="form">
  <nz-tabset [nzAnimated]="false">
    <nz-tab [nzTitle]="'app.register.tab-register' | i18n">
      <nz-alert
        *ngIf="error"
        [nzType]="'error'"
        [nzMessage]="error"
        [nzShowIcon]="true"
        class="mb-lg"
      />
      <nz-form-item>
        <nz-form-control [nzErrorTip]="companyErrorTip">
          <nz-input-group nzSize="large" nzPrefixIcon="global">
            <input
              nz-input
              formControlName="company"
              [placeholder]="'app.register.company.placeholder' | i18n"
            />
          </nz-input-group>
          <ng-template #companyErrorTip let-i>
            <ng-container *ngIf="i.errors?.required">
              {{ 'validation.register.company.required' | i18n }}
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-control [nzErrorTip]="userErrorTip">
          <nz-input-group nzSize="large" nzPrefixIcon="user">
            <input
              nz-input
              formControlName="nickName"
              [placeholder]="'app.register.name.placeholder' | i18n"
            />
          </nz-input-group>
          <ng-template #userErrorTip let-i>
            <ng-container *ngIf="i.errors?.required">
              {{ 'validation.register.name.required' | i18n }}
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-control [nzErrorTip]="mobileErrorTip">
          <nz-input-group nzSize="large" [nzAddOnBefore]="addOnBeforeTemplate">
            <ng-template #addOnBeforeTemplate>
              <nz-select formControlName="mobilePrefix" style="width: 100px">
                <nz-option [nzLabel]="'+86'" [nzValue]="'+86'" />
              </nz-select>
            </ng-template>
            <input
              formControlName="mobile"
              nz-input
              [placeholder]="'app.login.phone-number.placeholder' | i18n"
            />
          </nz-input-group>
          <ng-template #mobileErrorTip let-i>
            <ng-container *ngIf="i.errors?.required">
              {{ 'validation.phone-number.required' | i18n }}
            </ng-container>
            <ng-container *ngIf="i.errors?.pattern">
              {{ 'validation.phone-number.wrong-format' | i18n }}
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'validation.verification-code.required' | i18n">
          <nz-row [nzGutter]="8">
            <nz-col [nzSpan]="16">
              <nz-input-group nzSize="large" nzPrefixIcon="mail">
                <input
                  nz-input
                  formControlName="captcha"
                  [placeholder]="'app.login.verification-code.placeholder' | i18n"
                  maxlength="4"
                />
              </nz-input-group>
            </nz-col>
            <nz-col [nzSpan]="8">
              <button
                type="button"
                nz-button
                nzSize="large"
                (click)="getCaptcha()"
                [disabled]="count > 0"
                nzBlock
                [nzLoading]="loading"
              >
                {{ count ? count + 's' : ('app.register.get-verification-code' | i18n) }}
              </button>
            </nz-col>
          </nz-row>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-col [nzSpan]="24">
          <label nz-checkbox formControlName="check">{{ 'app.register.have-read' | i18n }}</label>
          <a href="https://proficloud-io.cn/software-license-terms-international/" target="_blank">
            《{{ 'app.register.registration.agreement' | i18n }}》
          </a>
          <a href="https://proficloud-io.cn/terms-and-conditions/" target="_blank">
            《{{ 'app.register.platform.terms' | i18n }}》
          </a>
          <a href="https://proficloud-io.cn/data-privacy/" target="_blank">
            《{{ 'app.register.data.privacy' | i18n }}》
          </a>
        </nz-col>
      </nz-form-item>
      <nz-form-item>
        <button
          [disabled]="!form.controls.check.value"
          nz-button
          nzType="primary"
          nzSize="large"
          type="submit"
          [nzLoading]="loading"
          class="submit"
        >
          {{ 'app.register.register' | i18n }}
        </button>
      </nz-form-item>
      <div class="redirect2register">
        {{ 'app.register.sign-in' | i18n }}
        <a routerLink="/passport/login">{{ 'app.register.login' | i18n }}</a>
      </div>
    </nz-tab>
  </nz-tabset>
</form>
